const random = ({ text, body = "" }) => {
  console.log("\x1b[35m%s\x1b[0m", `RANDOM: ${text} \n `, body);
};

const success = ({ text, body = "" }) => {
  console.log("\x1b[34m%s\x1b[0m", `SUCCESS: ${text} \n `, body);
};

const error = ({ text, error = "" }) => {
  console.log("\x1b[31m%s\x1b[0m", `ERROR: ${text} \n `, error);
};

const LOGGER = {
  random,
  success,
  error,
};

export { LOGGER };
